import React from "react";

const Graph: React.FC = () => {
  return (
    <div className="p-8 bg-gray-50 min-h-screen">
      <div className="bg-white rounded-xl p-8 shadow-sm">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Graph</h2>
        <p className="text-gray-600">Graph visualization will be implemented here.</p>
      </div>
    </div>
  );
};

export default Graph;

